import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Route from 'react-router-dom/Route'
import { BrowserRouter, Switch } from 'react-router-dom'

import { ScrollContext } from 'react-router-scroll-4';
import './index.scss';


import store from './store';
import App from './components/app';
import Login from './components/login/login'
import Logout from './components/login/logout'
import Register  from './components/login/register'
// import LmRegister  from './components/login/lmregister'
// import LmLogin  from './components/login/lmlogin'
// import AuthCallBack  from './components/login/authcallback'
// import ForgetPassword  from './components/pages/forget-password'

import ChangePasswordComponent from './components/manage/changepassword.component';
import ResetPassword from './components/login/reset-password';
import Error404 from './components/pages/error-404';
import LmStates from "./components/layouts/lmstates";
import LmVehicleCapacity from "./components/layouts/lmvehiclecapacity";
import LmFreights from "./components/layouts/lmfreights";
import LmRouteConfig from "./components/layouts/lmrouteconfig";
import LmConsignees from "./components/layouts/lmconsignees";
import LmBaseConfig from "./components/layouts/lmbaseconfig";
import LmLoadManager from "./components/layouts/lmloadmanager";
import LmTransporters from "./components/layouts/lmtransporters";
import LmAddTransporters from "./components/layouts/lmaddtransporters";
import LmShareOfBusiness from "./components/layouts/lmshareofbusiness";
import LmCurrentShareOfBusiness from "./components/layouts/lmcurrentsob";
import LmLoadShare from "./components/layouts/lmloadshare";
import LmSobZones from "./components/layouts/lmsobzones";
import LmLoadSummary from "./components/layouts/lmloadsummary";
import LmTruckloadAuditLog from "./components/layouts/lmtruckloadauditlog";
import LmTruckloadScanDashboard from "./components/layouts/lmtruckloadscandashboard";
import LmTruckAvailability from "./components/layouts/lmtruckavailability";
import LmLoadingPorts from "./components/layouts/lmloadingports";
import LmVOutput from "./components/layouts/lmvoutput";
import LmVOutputDetails from "./components/layouts/lmvoutputdetails";
import LmDepartments from "./components/layouts/lmdepartments";
import LmUsers from "./components/layouts/lmusers";
import LmRoles from "./components/layouts/lmroles";
import LmUserActivities from "./components/layouts/lmuseractivities";
import LmPageAccess from "./components/layouts/lmpageaccess";
import LmUserLogReport from "./components/layouts/lmuserlogreport";
import NexaScreen from './components/layouts/lmnexascreen.js';
import PowerBIScreen from './components/layouts/power_bi_dashboard.js';
import ViewLoadSummaryDetails from './components/layouts/viewLoadSummaryDetails.js';
import AuthCallBack from './components/login/authcallback.js';
import EnmUserLogin from './components/login/enmuserlogin.js';
import Dashboard from './components/layouts/msilDashboard/Dashboard.jsx'
import HubMaster from './components/layouts/hubmaster.js';
import HubOperatorMaster from './components/layouts/hubOperatorMaster.js';
import HubPerformanceConfig from './components/layouts/hubPerformanceConfig.js';
import ConsigneeHolidayCalendar from './components/layouts/consigneeHolidayCalendar.js';
import HubSourceMapping from './components/layouts/hubsourcemapping.js';
import HubConsigneeCityMapping from './components/layouts/hubconsigneecitymapping.js';
import OrderDayMaster from './components/layouts/orderdatmaster.js';
import AirCourierConfig from './components/layouts/airCourierConfig.js';
import MobileTruckLoadShell from './components/layouts/mobileTruckLoad/MobileTruckLoadShell.jsx';
import MobileLanding from './components/layouts/mobileTruckLoad/MobileLanding.jsx';
import MobileDashboard from './components/layouts/mobileTruckLoad/MobileDashboard.jsx';
import MobileInputPlan from './components/layouts/mobileTruckLoad/MobileInputPlan.jsx';
import MobileScan from './components/layouts/mobileTruckLoad/MobileScan.jsx';
import MobileSummary from './components/layouts/mobileTruckLoad/MobileSummary.jsx';

class Root extends React.Component {
    render() {
        return (
        <Provider store={store}>
            <BrowserRouter basename={'/'}>
                <ScrollContext>
                    <Switch>
 
                        <Route exact path={`${process.env.PUBLIC_URL}/`} component={Login} />
                        <Route exact path={`${process.env.PUBLIC_URL}/optirun`} component={Login} />
                        <Route exact path={`${process.env.PUBLIC_URL}/tptlogin`} component={Login} />
                        <Route path={`${process.env.PUBLIC_URL}/resetpassword`} component={ResetPassword} />
                        <Route path={`${process.env.PUBLIC_URL}/register`} component={Register} />
                        <Route path={`${process.env.PUBLIC_URL}/authcallback`} component={AuthCallBack} />
                        <Route exact path={`${process.env.PUBLIC_URL}/enmuserlogin/:token`} component={EnmUserLogin} />

                        {/* Own Switch branch (real "path" prop, not just a bare wrapper) so it's
                            actually reachable - <App> below has no path of its own, so per
                            react-router v4 Switch's matching (a pathless child falls back to
                            "always matches"), it would otherwise swallow every URL that isn't one
                            of the explicit routes above, including these, if this branch were
                            listed after it. Must stay before <App> for the same reason. */}
                        <Route path={`${process.env.PUBLIC_URL}/lm-mobile`} render={() => (
                            <MobileTruckLoadShell>
                                <Switch>
                                    <Route path={`${process.env.PUBLIC_URL}/lm-mobile/landing`} component={MobileLanding} />
                                    <Route path={`${process.env.PUBLIC_URL}/lm-mobile/dashboard`} component={MobileDashboard} />
                                    <Route path={`${process.env.PUBLIC_URL}/lm-mobile/input-plan`} component={MobileInputPlan} />
                                    {/* transactionId/tripNo are optional path params (not query/state) so a
                                        real page refresh can rebuild the screen from the backend instead of
                                        depending on ctx.session (wiped on refresh) or router location.state
                                        (browser-dependent whether it survives one) - see
                                        MobileTruckLoadContext.resumeSessionFromIds. Optional (":x?") so a bare
                                        /lm-mobile/scan still matches too, for any navigation that hasn't been
                                        updated to include them. */}
                                    <Route path={`${process.env.PUBLIC_URL}/lm-mobile/scan/:transactionId?/:tripNo?`} component={MobileScan} />
                                    <Route path={`${process.env.PUBLIC_URL}/lm-mobile/summary/:transactionId?/:tripNo?`} component={MobileSummary} />
                                </Switch>
                            </MobileTruckLoadShell>
                        )} />

                       <App>

                        <Route path={`${process.env.PUBLIC_URL}/logout`} component={Logout} />
                        <Route path={`${process.env.PUBLIC_URL}/error-404`} component={Error404} />
                        <Route path={`${process.env.PUBLIC_URL}/profile/changepassword`} component={ChangePasswordComponent} />
                        <Route path={`${process.env.PUBLIC_URL}/lmstates`} component={LmStates} />
                        <Route path={`${process.env.PUBLIC_URL}/lmvehiclecapacity`} component={LmVehicleCapacity} />
                        <Route path={`${process.env.PUBLIC_URL}/lmfreights`} component={LmFreights} />
                        <Route path={`${process.env.PUBLIC_URL}/lmrouteconfig`} component={LmRouteConfig} />
                        <Route path={`${process.env.PUBLIC_URL}/lmconsignees`} component={LmConsignees} />
                        <Route path={`${process.env.PUBLIC_URL}/lmbaseconfig`} component={LmBaseConfig} />
                        <Route path={`${process.env.PUBLIC_URL}/lmloadmanager`} component={LmLoadManager} />
                        <Route path={`${process.env.PUBLIC_URL}/lmtransporters`} component={LmTransporters} />
                        <Route path={`${process.env.PUBLIC_URL}/lmaddtransporters`} component={LmAddTransporters} />
                        <Route path={`${process.env.PUBLIC_URL}/lmshareofbusiness`} component={LmShareOfBusiness} />
                        <Route path={`${process.env.PUBLIC_URL}/lmcurrentsob`} component={LmCurrentShareOfBusiness} />
                        <Route path={`${process.env.PUBLIC_URL}/lmloadshare/:eventname`} component={LmLoadShare} />
                        <Route path={`${process.env.PUBLIC_URL}/lmsobzones`} component={LmSobZones} />
                        <Route path={`${process.env.PUBLIC_URL}/lmloadsummary`} component={LmLoadSummary} />
                        <Route path={`${process.env.PUBLIC_URL}/loading-plan-audit-log`} component={LmTruckloadAuditLog} />
                        <Route path={`${process.env.PUBLIC_URL}/vehicle-loading-dashboard`} component={LmTruckloadScanDashboard} />
                        <Route path={`${process.env.PUBLIC_URL}/lmtruckavailability/:eventname`} component={LmTruckAvailability} />
                        <Route path={`${process.env.PUBLIC_URL}/lmloadingports`} component={LmLoadingPorts} />
                        <Route path={`${process.env.PUBLIC_URL}/lmvoutput`} component={LmVOutput} />
                        <Route path={`${process.env.PUBLIC_URL}/lmvoutputdetails/:eventname`} component={LmVOutputDetails} />
                        <Route path={`${process.env.PUBLIC_URL}/lmdepartments`} component={LmDepartments} />
                        <Route path={`${process.env.PUBLIC_URL}/lmusers`} component={LmUsers} />
                        <Route path={`${process.env.PUBLIC_URL}/lmroles`} component={LmRoles} />                      
                        <Route path={`${process.env.PUBLIC_URL}/lmwelcome`} component={PowerBIScreen} />
                        <Route path={`${process.env.PUBLIC_URL}/lmpageaccess`} component={LmPageAccess} />                        
                        <Route path={`${process.env.PUBLIC_URL}/lmuserlogreport`} component={LmUserLogReport} />
                        <Route path={`${process.env.PUBLIC_URL}/nexascreen`} component={NexaScreen} />
                        <Route path={`${process.env.PUBLIC_URL}/lmuseractivities`} component={LmUserActivities} />
                        <Route path={`${process.env.PUBLIC_URL}/viewLoadSummaryDetails/:eventname`} component={ViewLoadSummaryDetails} />
                        <Route path={`${process.env.PUBLIC_URL}/msil-dashboard`} component={Dashboard} />


                        <Route path={`${process.env.PUBLIC_URL}/hub-master`} component={HubMaster} />
                        <Route path={`${process.env.PUBLIC_URL}/hub-operator-master`} component={HubOperatorMaster} />
                        <Route path={`${process.env.PUBLIC_URL}/hub-performance-config`} component={HubPerformanceConfig} />
                        <Route path={`${process.env.PUBLIC_URL}/consignee-holiday-calendar`} component={ConsigneeHolidayCalendar} />
                        <Route path={`${process.env.PUBLIC_URL}/hub-consignee-city-mapping`} component={HubSourceMapping} />
                        <Route path={`${process.env.PUBLIC_URL}/hub-city-freights`} component={HubConsigneeCityMapping} />
                        <Route path={`${process.env.PUBLIC_URL}/order-day-master`} component={OrderDayMaster} />
                        <Route path={`${process.env.PUBLIC_URL}/air-courier-config`} component={AirCourierConfig} />
                        </App>

                    </Switch>
                </ScrollContext>
            </BrowserRouter>
        </Provider>
        )
    }
}



ReactDOM.render(<Root/>, document.getElementById('root'));


